  (function() {
    // ---------- Helper functions ----------
    const formatMoney = (cents) => (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    const escapeHtml = (str) => String(str).replace(/[&<>]/g, m => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;' })[m]);

    // Milestone SVG icons
    const milestoneIcons = {
      50: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>`,
      70: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>`,
      90: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>`
    };

    // DOM elements
    const cartCountSpan = document.getElementById('CartDrawerCount');
    const cartTotalSpan = document.getElementById('CartTotalPrice');
    const cartItemsDiv = document.getElementById('CartItemsList');
    const recommendationsDiv = document.getElementById('RecommendationsList');
    const milestonesDiv = document.getElementById('MilestoneCircles');
    const freeShippingMsg = document.getElementById('FreeShippingMessage');

    // Fetch cart data
    const getCart = async () => {
      const res = await fetch('/cart.js');
      return res.json();
    };

    // Load recommendations using Shopify API + fallback
    const loadRecommendations = async (productId) => {
      if (!recommendationsDiv) return;
      try {
        const recRes = await fetch(`/recommendations/products.json?product_id=${productId}&limit=3`);
        const recData = await recRes.json();
        let products = recData.products || [];
        if (products.length === 0) {
          const fallbackHandles = ['dark-opial', 'libra', 'the-savage'];
          const fetchProduct = async (handle) => {
            try {
              const res = await fetch(`/products/${handle}.js`);
              return await res.json();
            } catch { return null; }
          };
          const fallbackProducts = await Promise.all(fallbackHandles.map(fetchProduct));
          products = fallbackProducts.filter(p => p !== null);
        }
        if (products.length === 0) {
          recommendationsDiv.innerHTML = '<div class="text-center text-xs py-2 text-muted-foreground">Keine Empfehlungen verfügbar</div>';
          return;
        }
        let html = '<div class="recommendations-section"><div class="rec-title">Passt dazu</div><div class="rec-list">';
        for (const p of products) {
          let imgSrc = '';
          if (p.featured_image) {
            imgSrc = typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.url;
          }
          if (!imgSrc && p.images && p.images.length) {
            imgSrc = typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src;
          }

          const variants = p.variants || [];
          if (variants.length === 0) continue;

          const minPrice = Math.min(...variants.map(v => v.price));
          const priceDisplay = variants.length > 1 ? `Ab ${formatMoney(minPrice)}` : formatMoney(minPrice);

          html += `
            <div class="rec-product-container">
              <div class="rec-item">
                <div class="rec-image">
                  <img src="${imgSrc}" alt="${escapeHtml(p.title)}" onerror="this.src='data:image/svg+xml,%3Csvg xmlns=\\'http://www.w3.org/2000/svg\\' viewBox=\\'0 0 100 100\\'%3E%3Crect width=\\'100\\' height=\\'100\\' fill=\\'%23ede8e1\\'/%3E%3Ctext x=\\'50\\' y=\\'55\\' text-anchor=\\'middle\\' fill=\\'%239b8d7a\\'%3E📷%3C/text%3E%3C/svg%3E'">
                </div>
                <div class="rec-info">
                  <div class="rec-item-title">${escapeHtml(p.title)}</div>
                  <div class="rec-price">${priceDisplay}</div>
                </div>
                <button class="rec-add-btn" data-product-id="${p.id}" ${variants.length === 1 ? `data-vid="${variants[0].id}"` : ''}>+ HINZUFÜGEN</button>
              </div>
          `;

          if (variants.length > 1) {
            html += `
              <div class="rec-variants-box m-hidden" id="rec-variants-${p.id}">
                <div class="rec-variants-header">
                  <span>GRÖSSE WÄHLEN</span>
                  <button class="rec-variants-close" data-product-id="${p.id}">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"></path></svg>
                  </button>
                </div>
                <div class="rec-variants-list">
            `;
            for (const v of variants) {
              let tagHtml = '';
              let descHtml = '';
              const titleLower = v.title.toLowerCase();
              if (titleLower.includes('15') || titleLower.includes('15ml') || titleLower.includes('15 ml')) {
                descHtml = 'Perfekt zum Ausprobieren';
              } else if (titleLower.includes('30') || titleLower.includes('30ml') || titleLower.includes('30 ml')) {
                tagHtml = '<span class="rec-variant-tag bestseller">BESTSELLER</span>';
                descHtml = 'Beliebt 🔥';
              } else if (titleLower.includes('50') || titleLower.includes('50ml') || titleLower.includes('50 ml')) {
                tagHtml = '<span class="rec-variant-tag spare">SPARE 21%</span>';
                descHtml = 'Bestes Preis-Leistungs-Verhältnis';
              }

              const isBestseller = tagHtml.includes('BESTSELLER') ? 'is-bestseller' : '';
              const comparePrice = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : null;
              
              const priceHtml = comparePrice
                ? `<div class="rec-variant-compare-price">${formatMoney(comparePrice)}</div><div class="rec-variant-price">${formatMoney(v.price)}</div>`
                : `<div class="rec-variant-price">${formatMoney(v.price)}</div>`;

              html += `
                  <div class="rec-variant-card ${isBestseller}" data-vid="${v.id}">
                    <div class="rec-variant-card-left">
                      <div class="rec-variant-card-title-row">
                        <span class="rec-variant-title">${escapeHtml(v.title)}</span>
                        ${tagHtml}
                      </div>
                      ${descHtml ? `<div class="rec-variant-desc">${descHtml}</div>` : ''}
                    </div>
                    <div class="rec-variant-card-right">
                      ${priceHtml}
                    </div>
                  </div>
              `;
            }
            html += `
                </div>
              </div>
            `;
          }
          html += `</div>`;
        }
        html += '</div></div>';
        recommendationsDiv.innerHTML = html;

        // attach events
        document.querySelectorAll('.rec-add-btn').forEach(btn => {
          btn.onclick = async (e) => {
            const vid = btn.dataset.vid;
            if (vid) {
              btn.innerHTML = '...';
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
              });
              refreshCartUI();
            } else {
              const pId = btn.dataset.productId;
              const box = document.getElementById(`rec-variants-${pId}`);
              if (box) box.classList.toggle('m-hidden');
            }
          };
        });

        document.querySelectorAll('.rec-variants-close').forEach(btn => {
          btn.onclick = (e) => {
            const pId = btn.dataset.productId;
            const box = document.getElementById(`rec-variants-${pId}`);
            if (box) box.classList.add('m-hidden');
          };
        });

        document.querySelectorAll('.rec-variant-card').forEach(card => {
          card.onclick = async (e) => {
            const vid = card.dataset.vid;
            if (vid) {
              card.style.opacity = '0.5';
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
              });
              refreshCartUI();
            }
          };
        });
      } catch(e) { console.warn(e); }
    };

    window.renderFreeGifts = () => {
      const fgList = document.getElementById('FreeGiftList');
      if (!fgList || !window.freeGiftsData) return;
      let currentList = window.freeGiftsData[window.fgFilter] || [];
      let filtered = currentList.filter(p => {
        if (window.fgSearchTerm && !p.title.toLowerCase().includes(window.fgSearchTerm.toLowerCase())) return false;
        return true;
      });
      let html = '';
      filtered.forEach(p => {
        const v = p.variants[0];
        if (!v) return;
        const isSelected = p.title === window.currentFreeGiftTitle;
        const bg = isSelected ? 'rgba(184, 158, 103, 0.08)' : '#f0ede8';
        const border = isSelected ? '2px solid #b28b5e' : '1px solid #eae6df';
        html += `
          <div class="flex-shrink-0 text-center add-free-gift" data-ftitle="${escapeHtml(p.title)}" data-fimage="${p.image}" style="width:64px; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:4px;" role="button" tabindex="0">
            <div style="width:56px; height:56px; overflow:hidden; background:${bg}; border:${border}; border-radius: 2px; transition:border-color 0.2s;" onmouseover="this.style.borderColor='#b28b5e'" onmouseout="if(!${isSelected}) this.style.borderColor='#eae6df'">
              <img src="${p.image}" style="width:100%; height:100%; object-fit:cover;">
            </div>
            <p style="width:56px; max-width:56px; font-size:7px; margin-top:4px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; color:#6b6257; text-align:center;">${escapeHtml(p.title)}</p>
          </div>
        `;
      });
      if (html === '') {
        fgList.innerHTML = '<span style="font-size:9px; color:var(--muted-text);">Keine 3ml Proben gefunden.</span>';
        return;
      }
      fgList.innerHTML = html;
      document.querySelectorAll('.add-free-gift').forEach(btn => {
        btn.onclick = async () => {
          btn.style.opacity = '0.5';
          const cartData = await getCart();
          if (cartData.items.length > 0) {
            let hostIndex = cartData.items.findIndex(i => i.properties && i.properties['Gratis Probe']);
            if (hostIndex === -1) hostIndex = 0;
            const item = cartData.items[hostIndex];
            const newProps = Object.assign({}, item.properties || {});
            newProps['Gratis Probe'] = btn.dataset.ftitle;
            newProps['_Gratis Probe Image'] = btn.dataset.fimage;
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                line: hostIndex + 1,
                quantity: item.quantity,
                properties: newProps
              })
            });
            refreshCartUI();
          }
        };
      });
    };

    // Main UI refresh
    const refreshCartUI = async () => {
      const cart = await getCart();
      const subtotal = cart.total_price / 100;
      
      const hostIndex = cart.items.findIndex(i => i.properties && i.properties['Gratis Probe']);
      window.currentFreeGiftTitle = hostIndex !== -1 ? cart.items[hostIndex].properties['Gratis Probe'] : null;
      if (hostIndex !== -1 && subtotal < 70) {
         const item = cart.items[hostIndex];
         const newProps = Object.assign({}, item.properties);
         newProps['Gratis Probe'] = '';
         newProps['_Gratis Probe Image'] = '';
         await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: hostIndex + 1,
              quantity: item.quantity,
              properties: newProps
            })
         });
         return refreshCartUI();
      }
      const remaining50 = Math.max(0, 50 - subtotal);
      const remaining70 = Math.max(0, 70 - subtotal);
      const remaining90 = Math.max(0, 90 - subtotal);
      const milestones = [50, 70, 90];

      if (cartCountSpan) cartCountSpan.innerText = `(${cart.item_count})`;
      if (cartTotalSpan) cartTotalSpan.innerText = formatMoney(cart.total_price);

      // Update global header cart bubble
      document.querySelectorAll('.m-cart-count-bubble, .m-cart-count').forEach(el => {
        el.innerText = cart.item_count;
        if (cart.item_count === 0) {
          el.classList.add('m:hidden');
        } else {
          el.classList.remove('m:hidden');
        }
      });

      if (freeShippingMsg) {
        if (subtotal >= 90) {
          freeShippingMsg.innerHTML = '✨ <span style="font-weight: 600; color:#b28b5e;">Alle Vorteile freigeschaltet!</span>';
        } else if (subtotal >= 70) {
          freeShippingMsg.innerHTML = `Noch <span style="font-weight: 600;">€${remaining90.toFixed(2)}</span> bis 🎫 10% Rabatt`;
        } else if (subtotal >= 50) {
          freeShippingMsg.innerHTML = `Noch <span style="font-weight: 600;">€${remaining70.toFixed(2)}</span> bis 🎁 Gratis 3ml Probe`;
        } else {
          freeShippingMsg.innerHTML = `Noch <span style="font-weight: 600;">€${remaining50.toFixed(2)}</span> bis 📦 Kostenloser Versand`;
        }
      }

      if (milestonesDiv) {
        let circlesHtml = '';
        milestones.forEach((threshold, idx) => {
          let status = 'inactive';
          if (subtotal >= threshold) status = 'completed';
          else if (subtotal >= threshold * 0.5) status = 'active';
          const iconSvg = milestoneIcons[threshold];
          circlesHtml += `
            <div class="m-milestone-circle">
              <div class="m-circle-icon ${status}">${iconSvg}</div>
              <span class="text-[7px] text-muted-foreground">€${threshold}</span>
            </div>
          `;
          if (idx < milestones.length-1) {
            const lineColor = subtotal >= milestones[idx] ? '#b28b5e' : '#e0dbd2';
            circlesHtml += `<div class="m-circle-line" style="background: ${lineColor};"></div>`;
          }
        });
        milestonesDiv.innerHTML = circlesHtml;
      }

      if (cartItemsDiv) {
        if (cart.items.length === 0) {
          cartItemsDiv.innerHTML = '<div class="text-center py-10 text-muted-foreground text-xs">Dein Warenkorb ist leer.</div>';
        } else {
          let itemsHtml = '';
          cart.items.forEach((item, idx) => {
            const line = idx + 1;
            let priceHtml = item.price === 0 ? `<span class="cart-item-price" style="color:#b28b5e;">Gratis</span>` : `<span class="cart-item-price">${formatMoney(item.final_line_price)}</span>`;
            let titleHtml = escapeHtml(item.product_title);
            if (item.properties && item.properties['_CustomTitle']) {
               titleHtml = escapeHtml(item.properties['_CustomTitle']);
            }
            let img1 = item.properties && (item.properties['Image 1'] || item.properties['_Image1']);
            let img2 = item.properties && (item.properties['Image 2'] || item.properties['_Image2']);
            let imageHtml = `<img src="${item.image}" alt="${escapeHtml(item.title)}">`;
            if (img1 && img2) {
               imageHtml = `
                 <div style="display: flex; gap: 0; align-items: center; justify-content: center; width: 100%; aspect-ratio: 1; background: #fff; padding: 0; box-sizing: border-box; border: 1px solid #eee; overflow: hidden;">
                   <div style="width: 50%; height: 100%; display: flex; align-items: center; justify-content: center; overflow: hidden;">
                     <img src="${img1}" style="width: 100%; height: 100%; object-fit: cover; display: block;">
                   </div>
                   <div style="width: 50%; height: 100%; display: flex; align-items: center; justify-content: center; overflow: hidden;">
                     <img src="${img2}" style="width: 100%; height: 100%; object-fit: cover; display: block;">
                   </div>
                 </div>
               `;
            }

            itemsHtml += `
              <div class="cart-item" data-line="${line}">
                <div class="cart-item-media" style="background: #ffffff !important;">${imageHtml}</div>
                <div class="cart-item-details">
                  <div class="flex justify-between items-start gap-2">
                    <div class="cart-item-title">${titleHtml}</div>
                    <button class="remove-item-btn" data-line="${line}"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button>
                  </div>
                  <div class="cart-item-variant">${escapeHtml(item.variant_title)}</div>
                  <div class="cart-item-row">
                      <div class="quantity-selector">
                        <button class="qty-btn qty-decr" data-line="${line}">−</button>
                        <span class="qty-value">${item.quantity}</span>
                        <button class="qty-btn qty-incr" data-line="${line}">+</button>
                      </div>
                      ${priceHtml}
                  </div>
                </div>
              </div>
            `;
          });

          let fgTitle = '';
          let fgImage = '';
          let hostItemIndex = -1;
          cart.items.forEach((item, i) => {
             if (item.properties && item.properties['Gratis Probe']) {
                 fgTitle = item.properties['Gratis Probe'];
                 fgImage = item.properties['_Gratis Probe Image'] || '';
                 hostItemIndex = i;
             }
          });

          if (hostItemIndex !== -1) {
            itemsHtml += `
              <div class="cart-item" data-line="free-gift" style="background:rgba(178,139,94,0.05); border:1px solid rgba(178,139,94,0.25); padding:8px;">
                <div class="cart-item-media"><img src="${fgImage}" alt="${fgTitle}"></div>
                <div class="cart-item-details">
                  <div class="flex justify-between items-start gap-2">
                    <div class="cart-item-title">${escapeHtml(fgTitle)} (Gratis)</div>
                    <button class="remove-free-gift-btn" style="cursor:pointer; color:var(--muted-text); background:none; border:none; padding:0;"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button>
                  </div>
                  <div class="cart-item-variant" style="color:var(--muted-text);">3 ml &middot; <span style="color:#b28b5e; font-weight:600;">Geschenk</span></div>
                  <div class="cart-item-row">
                    <span class="cart-item-price" style="color:#b28b5e; font-weight:600;">Gratis</span>
                  </div>
                </div>
              </div>
            `;
          }
          cartItemsDiv.innerHTML = itemsHtml;
          
          const removeFgBtn = cartItemsDiv.querySelector('.remove-free-gift-btn');
          if (removeFgBtn) {
            removeFgBtn.onclick = async () => {
               const item = cart.items[hostItemIndex];
               const newProps = Object.assign({}, item.properties);
               newProps['Gratis Probe'] = '';
               newProps['_Gratis Probe Image'] = '';
               await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    line: hostItemIndex + 1,
                    quantity: item.quantity,
                    properties: newProps
                  })
               });
               refreshCartUI();
            };
          }
        }
      }

      if (cart.items.length > 0) {
        loadRecommendations(cart.items[0].product_id);
      } else {
        if (recommendationsDiv) recommendationsDiv.innerHTML = '';
      }

      // Render free gift section
      const freeGiftContainer = document.getElementById('FreeGiftSectionContainer');
      if (freeGiftContainer && window.freeGiftsData) {
        const hasFreeGift = cart.items.some(i => i.properties && i.properties['Gratis Probe']);
        if (subtotal >= 70 && !hasFreeGift) {
          if (!document.getElementById('FreeGiftSection')) {
            freeGiftContainer.innerHTML = `
      <div id="FreeGiftSection" style="margin-top:12px; margin-bottom:12px; border:1px solid rgba(178,139,94,0.25); background:rgba(178,139,94,0.05); padding:12px;">
        <div style="display:flex; align-items:center; gap:6px; margin-bottom:8px;">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color:#b28b5e;"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>
          <span style="font-size:10px; font-weight:600; color:#b28b5e; font-family:var(--font-body);">Wähle deine Gratis-Probe</span>
        </div>
        <div style="display:flex; flex-direction:column; gap:8px; margin-bottom:8px;">
          <input type="text" id="FreeGiftSearch" placeholder="Suchen..." style="width:100%; font-size:10px; padding:4px 6px; border:1px solid var(--border-color); background:white; border-radius:2px;">
          <div style="display:flex; gap:4px; overflow-x:auto;">
            <button class="fg-filter active" data-filter="all" style="font-size:9px; padding:2px 6px; border:1px solid #b28b5e; background:#b28b5e; color:white; border-radius:2px;">Alle</button>
            <button class="fg-filter" data-filter="women" style="font-size:9px; padding:2px 6px; border:1px solid var(--border-color); background:white; border-radius:2px;">Damen</button>
            <button class="fg-filter" data-filter="men" style="font-size:9px; padding:2px 6px; border:1px solid var(--border-color); background:white; border-radius:2px;">Herren</button>
            <button class="fg-filter" data-filter="unisex" style="font-size:9px; padding:2px 6px; border:1px solid var(--border-color); background:white; border-radius:2px;">Unisex</button>
          </div>
        </div>
        <div id="FreeGiftList" style="display:flex; gap:6px; overflow-x:auto; padding-bottom:4px;"></div>
      </div>`;
            
            const fgSearchInput = document.getElementById('FreeGiftSearch');
            if (fgSearchInput) {
              fgSearchInput.addEventListener('input', (e) => {
                window.fgSearchTerm = e.target.value;
                if (typeof window.renderFreeGifts === 'function') window.renderFreeGifts();
              });
            }
            document.querySelectorAll('.fg-filter').forEach(btn => {
              btn.onclick = () => {
                document.querySelectorAll('.fg-filter').forEach(b => {
                  b.style.background = 'white';
                  b.style.color = 'black';
                  b.style.borderColor = 'var(--border-color)';
                  b.classList.remove('active');
                });
                btn.style.background = '#b28b5e';
                btn.style.color = 'white';
                btn.style.borderColor = '#b28b5e';
                btn.classList.add('active');
                window.fgFilter = btn.dataset.filter;
                if (typeof window.renderFreeGifts === 'function') window.renderFreeGifts();
              };
            });
          }
          window.fgSearchTerm = window.fgSearchTerm || '';
          window.fgFilter = window.fgFilter || 'all';
          if (typeof window.renderFreeGifts === 'function') window.renderFreeGifts();
        } else {
          freeGiftContainer.innerHTML = '';
        }
      }

      const footerFs = document.getElementById('FooterFreeShipping');
      if (footerFs) {
        if (subtotal >= 50) footerFs.classList.remove('m-hidden');
        else footerFs.classList.add('m-hidden');
      }

      let finalTotal = cart.total_price;

      // Hidden inputs for cart attributes removed since we now use line item properties
      const discountContainer = document.querySelector('[data-minimog-cart-discounts]');
      let appliedDiscountsHTML = '';
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        appliedDiscountsHTML += '<ul class="m-cart__discount" role="list" style="margin: 8px 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 4px;">';
        cart.cart_level_discount_applications.forEach(d => {
          appliedDiscountsHTML += `
            <li class="m-cart__discount--item" style="display: flex; justify-content: space-between; font-size: 10px; align-items: center;">
              <div style="display: flex; align-items: center; gap: 4px; color: var(--muted-text);">
                <svg width="12" height="12" viewBox="0 0 12 13" fill="currentColor"><path fill-rule="evenodd" d="M7 .5h3a2 2 0 0 1 2 2v3a.995.995 0 0 1-.293.707l-6 6a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l6-6A.995.995 0 0 1 7 .5z"/></svg>
                <span>${d.title}</span>
              </div>
              <span class="m-text-gold" style="color: #b28b5e; font-weight: 600;">−${formatMoney(d.total_allocated_amount)}</span>
            </li>
          `;
        });
        appliedDiscountsHTML += '</ul>';
      } else if (subtotal >= 90) {
        const discountAmount = Math.floor(finalTotal * 0.10);
        finalTotal -= discountAmount;
        appliedDiscountsHTML += `
          <ul class="m-cart__discount" role="list" style="margin: 8px 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 4px;">
            <li class="m-cart__discount--item" style="display: flex; justify-content: space-between; font-size: 10px; align-items: center;">
              <div style="display: flex; align-items: center; gap: 4px; color: var(--muted-text);">
                <svg width="12" height="12" viewBox="0 0 12 13" fill="currentColor"><path fill-rule="evenodd" d="M7 .5h3a2 2 0 0 1 2 2v3a.995.995 0 0 1-.293.707l-6 6a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l6-6A.995.995 0 0 1 7 .5z"/></svg>
                <span>10% Discount</span>
              </div>
              <span class="m-text-gold" style="color: #b28b5e; font-weight: 600;">−${formatMoney(discountAmount)}</span>
            </li>
          </ul>
        `;
      }
      if (discountContainer) discountContainer.innerHTML = appliedDiscountsHTML;
      if (cartTotalSpan) cartTotalSpan.innerText = formatMoney(finalTotal);
    };

    // AJAX quantity / remove
    const changeQuantity = async (line, qty) => {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      });
      refreshCartUI();
    };
    const removeItem = (line) => changeQuantity(line, 0);

    // Event delegation for cart actions
    document.body.addEventListener('click', (e) => {
      const remove = e.target.closest('.remove-item-btn');
      if (remove) {
        const line = Number(remove.dataset.line);
        if (!isNaN(line)) removeItem(line);
        e.preventDefault();
        return;
      }
      const decr = e.target.closest('.qty-decr');
      if (decr) {
        const line = Number(decr.dataset.line);
        const qtySpan = decr.nextElementSibling;
        let qty = parseInt(qtySpan.innerText);
        if (qty > 1) changeQuantity(line, qty - 1);
        e.preventDefault();
        return;
      }
      const incr = e.target.closest('.qty-incr');
      if (incr) {
        const line = Number(incr.dataset.line);
        const qtySpan = incr.previousElementSibling;
        let qty = parseInt(qtySpan.innerText);
        changeQuantity(line, qty + 1);
        e.preventDefault();
      }
    });

    // Discount toggle & apply
    const toggleBtn = document.getElementById('DiscountToggleBtn');
    const discountInputDiv = document.getElementById('DiscountInputDiv');
    if (toggleBtn && discountInputDiv) {
      toggleBtn.onclick = () => discountInputDiv.classList.toggle('m-hidden');
    }
    const applyBtn = document.getElementById('ApplyDiscountBtn');
    if (applyBtn) {
      applyBtn.onclick = async (e) => {
        e.preventDefault();
        const code = document.getElementById('DiscountCodeInput').value.trim();
        const fb = document.getElementById('DiscountFeedback');
        if (code) {
          fb.innerText = 'Wird angewendet...';
          fb.style.color = '#b28b5e';
          fb.classList.remove('m-hidden');
          
          await fetch(`/discount/${code}`);
          
          setTimeout(async () => {
            await refreshCartUI();
            fb.innerText = '✔ Rabattcode angewendet';
            fb.style.color = '#38a169';
            setTimeout(() => fb.classList.add('m-hidden'), 4000);
          }, 800);
        } else {
          fb.innerText = 'Bitte gib einen Code ein';
          fb.style.color = '#e53e3e';
          fb.classList.remove('m-hidden');
          setTimeout(() => fb.classList.add('m-hidden'), 4000);
        }
      };
    }

    // Aggressively remove default toast notification
    const killNotifications = () => {
      const selectors = ['.cart-notification', '[data-cart-notification]', '.toast', '.alert-success', '.shopify-message'];
      selectors.forEach(sel => document.querySelectorAll(sel).forEach(el => el.remove()));
      document.querySelectorAll('div, p, span').forEach(el => {
        if (el.innerText && el.innerText.includes('Produkt wurde in den Warenkorb gelegt')) el.remove();
      });
    };
    const notifObserver = new MutationObserver(killNotifications);
    notifObserver.observe(document.body, { childList: true, subtree: true });
    setInterval(killNotifications, 200);
    killNotifications();

    // Ensure drawer opens after add-to-cart
    const origFetch = window.fetch;
    window.fetch = function(...args) {
      return origFetch.apply(this, args).then(async (res) => {
        if (args[0] && typeof args[0] === 'string' && (args[0].includes('/cart/add.js') || args[0].includes('/cart/add'))) {
          setTimeout(() => {
            const drawer = document.querySelector('m-cart-drawer');
            if (drawer && !drawer.classList.contains('open')) drawer.classList.add('open');
            refreshCartUI();
          }, 60);
        }
        return res;
      });
    };

    // Initial load
    refreshCartUI();
  })();
